import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Title = styled.h2.withConfig({
  displayName: "Title",
  componentId: "sc-io01be-0"
})(["display:block;margin-top:auto;margin-bottom:auto;font-size:16px;line-height:18px;", ";", ";", ";"], getFont(0, 'compact'), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(0, 'compact')), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 18px;\n  "]))));